(function() {
  'use strict';

  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* --- Scroll Reveal (fade-in) --- */
  function initScrollReveal() {
    const elements = document.querySelectorAll('.pixkom-fade-in');
    if (!elements.length) return;

    if (prefersReducedMotion) {
      elements.forEach(el => el.classList.add('is-visible'));
      return;
    }

    const observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.2, rootMargin: '0px 0px -40px 0px' });

    elements.forEach(function(el) { observer.observe(el); });
  }

  /* --- Counter Animation --- */
  function initCounters() {
    const counters = document.querySelectorAll('.pixkom-counter[data-target]');
    if (!counters.length) return;

    if (prefersReducedMotion) {
      counters.forEach(function(el) { el.textContent = el.dataset.target; });
      return;
    }

    const observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          animateCounter(entry.target);
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.2 });

    counters.forEach(function(el) { observer.observe(el); });
  }

  function animateCounter(el) {
    var target = parseInt(el.dataset.target, 10);
    var duration = 600;
    var start = performance.now();

    function update(now) {
      var t = Math.min((now - start) / duration, 1);
      var eased = 1 - Math.pow(1 - t, 4); /* easeOutQuart */
      el.textContent = Math.round(eased * target);
      if (t < 1) requestAnimationFrame(update);
    }

    requestAnimationFrame(update);
  }

  /* --- Header Compact + Announcement Bar --- */
  function initHeaderCompact() {
    var header = document.querySelector('sticky-header');
    var announcement = document.querySelector('.pixkom-announcement-bar');
    if (!header) return;

    var threshold = announcement ? announcement.offsetHeight : 50;
    var isCompact = false;

    function onScroll() {
      var shouldCompact = window.scrollY > threshold;
      if (shouldCompact === isCompact) return;
      isCompact = shouldCompact;

      if (isCompact) {
        header.classList.add('header-compact');
        document.body.classList.add('scrolled-past-announcement');
      } else {
        header.classList.remove('header-compact');
        document.body.classList.remove('scrolled-past-announcement');
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* --- Parallax Glow Orbs --- */
  function initParallaxGlow() {
    if (prefersReducedMotion) return;

    var glows = document.querySelectorAll('.pixkom-parallax-glow');
    if (!glows.length) return;

    var ticking = false;
    window.addEventListener('scroll', function() {
      if (!ticking) {
        requestAnimationFrame(function() {
          var offset = window.scrollY;
          glows.forEach(function(el) {
            el.style.transform = 'translateY(' + (offset * -0.1) + 'px)';
          });
          ticking = false;
        });
        ticking = true;
      }
    }, { passive: true });
  }

  /* --- Init all on DOM ready --- */
  document.addEventListener('DOMContentLoaded', function() {
    initScrollReveal();
    initCounters();
    initHeaderCompact();
    initParallaxGlow();
  });
})();
